<template>
  <div class="task-list">

    <span v-if="taskLists" style="display: flex; width: 100%">
      <TaskList
        v-for="tl in taskLists"
        :key="tl.id"
        :id="tl.id"
        :taskList="tl"
        @taskListUpdated="$emit('rowUpdated')"
        @deleteTaskList="removeTaskList($event)"
        ></TaskList>

      <div
        :bordered="false"
        :class="{'nextList': true}"
        @click="onPlusClick"
        >
          <div :class="{'nextListIcon': true}">
            <a-icon type="plus"/>
          </div>
        </div>
    </span>

  </div>
</template>

<script>
import TaskList from '@/components/TaskList';
import { shortId } from '@/utils';

export default {
  name: "TaskRow",
  props: ["id", "taskLists"],
  components: {
    TaskList
  },
  updated(){
    // console.log("TaskRow updated");
    // this.$emit("rowUpdated");
  },
  methods: {
    addNewTaskList(position) {
      const newTaskList = {id: shortId(), tasks: []};
      this.$store.commit(
        'boards/addTaskList',
        {taskLists: this.taskLists, position, taskList: newTaskList}
      );
      this.$emit("rowUpdated");
    },
    removeTaskList(event) {
      this.$store.commit(
        'boards/removeTaskList',
        {taskLists: this.taskLists, id: event.id},
      );
      this.$emit("rowUpdated");
      if (this.taskLists.length === 0) {
        this.$emit("removeRow", {"id": this.id})
      }
    },

    onPlusClick() {
      this.addNewTaskList(this.taskLists.length);
    },
  }
}
</script>

<style scoped>

.task-list {
  display: flex;
}

.nextList {
  background-color: white;
  cursor: pointer;
  margin-bottom: 15px;
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 15px;
  opacity: .2;
  width: 25px;
}

.nextList:hover {
  opacity: .5;
}

.nextListIcon {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
}

</style>


